/* AAA homepage — product rail arrows. Native scroll does the work; the
   buttons only nudge it by one viewport and reflect where it is. */
(function () {
  'use strict';
  function initRail(root) {
    var track = root.querySelector('[data-aaa-track]');
    var btns = root.querySelectorAll('.aaa-rail__btn');
    if (!track || !btns.length) return;
    var prev = btns[0], next = btns[1];
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aaa-rail]'), initRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Category tiles: product cut-outs come with wildly different amounts of
   white space. Measure each image's actual subject (non-white pixels) and
   scale/centre it so every object fills its tile the same way. Same-origin
   CDN images, so the canvas read is allowed; any failure leaves the plain
   object-fit:contain image in place. */
(function () {
  'use strict';
  var FILL = 0.86, MAX = 2.6;
  function measure(img) {
    try {
      var n = 72, c = document.createElement('canvas');
      var a = img.naturalWidth / img.naturalHeight;
      var w = a >= 1 ? n : Math.round(n * a), h = a >= 1 ? Math.round(n / a) : n;
      c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data;
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var yy = 0; yy < h; yy++) {
        for (var xx = 0; xx < w; xx++) {
          var i = (yy * w + xx) * 4;
          if (d[i + 3] < 24) continue;
          if (d[i] > 236 && d[i + 1] > 236 && d[i + 2] > 236) continue;
          if (xx < x0) x0 = xx; if (xx > x1) x1 = xx;
          if (yy < y0) y0 = yy; if (yy > y1) y1 = yy;
        }
      }
      if (x1 < 0) return null;
      return { l: x0 / w, r: (x1 + 1) / w, t: y0 / h, b: (y1 + 1) / h, a: a };
    } catch (e) { return null; }
  }
  function apply(img) {
    var m = img._aaaBox;
    if (!m) return;
    var W = img.clientWidth, H = img.clientHeight;
    if (!W || !H) return;
    var rw, rh;
    if (m.a > W / H) { rw = W; rh = W / m.a; } else { rh = H; rw = H * m.a; }
    var bw = (m.r - m.l) * rw, bh = (m.b - m.t) * rh;
    var s = Math.min(W * FILL / bw, H * FILL / bh, MAX);
    if (s < 1) s = 1;
    var cx = ((m.l + m.r) / 2 - 0.5) * rw, cy = ((m.t + m.b) / 2 - 0.5) * rh;
    img.style.setProperty('--aaa-s', s.toFixed(3));
    img.style.setProperty('--aaa-tx', (-cx * s).toFixed(1) + 'px');
    img.style.setProperty('--aaa-ty', (-cy * s).toFixed(1) + 'px');
    img.classList.add('is-fit');
  }
  function prep(img) {
    function go() {
      if (!img.naturalWidth) return;
      img._aaaBox = measure(img);
      apply(img);
    }
    if (img.complete && img.naturalWidth) go();
    else img.addEventListener('load', go, { once: true });
  }
  function boot() {
    var imgs = document.querySelectorAll('img[data-aaa-fit]');
    Array.prototype.forEach.call(imgs, prep);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (es) { es.forEach(function (e) { apply(e.target); }); });
      Array.prototype.forEach.call(imgs, function (i) { ro.observe(i); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Shopify Inbox launcher: keep it off the hero and the first section
   heading. It appears once the visitor is past the hero, and stays put for
   good once they've touched it (so an open chat never vanishes on scroll). */
(function () {
  'use strict';
  var root = document.documentElement, engaged = false, hero = document.querySelector('.aaa-top');
  function limit() { return hero ? hero.getBoundingClientRect().bottom + window.scrollY - window.innerHeight * 0.25 : window.innerHeight; }
  function sync() {
    if (engaged) return;
    root.classList.toggle('aaa-chat-on', window.scrollY > limit());
  }
  window.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('shopify-chat, #ShopifyChat, inbox-online-store-chat')) {
      engaged = true; root.classList.add('aaa-chat-on');
    }
  }, true);
  sync();
})();

/* Swipe rails: a thin progress track under each horizontally scrolling list
   shows how much is left. Hidden by CSS when the list doesn't scroll. */
(function () {
  'use strict';
  function init(list) {
    var host = list.parentNode, bar = host.querySelector('.aaa-scrollbar');
    if (!bar) return;
    var thumb = bar.firstElementChild;
    function sync() {
      var sw = list.scrollWidth, cw = list.clientWidth;
      var scrolls = sw - cw > 4;
      bar.classList.toggle('is-on', scrolls);
      if (!scrolls) return;
      var w = Math.max(cw / sw, 0.12);
      var p = list.scrollLeft / (sw - cw);
      thumb.style.width = (w * 100).toFixed(2) + '%';
      thumb.style.transform = 'translateX(' + (p * (1 / w - 1) * 100).toFixed(2) + '%)';
    }
    list.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-aaa-scroll]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
